import { Toman } from '@insta-club/components/icons';

interface Props {
    title: string;
    value: string;
    price?: boolean;
}

const AmountRow: React.FC<Props> = ({ title, value, price = true }) => {
    return (
        <li className='flex items-center justify-between pt-4 pb-2.5 first:pt-0 last:pb-0'>
            <span className='text-sm font-normal text-gray-500'>{title}</span>
            <div className='flex items-center space-x-0.5'>
                <span className='text-base font-medium text-gray-800'>{value}</span>
                {price ? <Toman className='relative bottom-0.5 text-gray-400' /> : null}
            </div>
        </li>
    );
};

export default AmountRow;

